import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2899faae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { for: "selectNameInput" }
const _hoisted_4 = { class: "input-container" }
const _hoisted_5 = ["onKeypress"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#000000"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

import {ref, onMounted} from 'vue';
  
export default /*#__PURE__*/_defineComponent({
  name: 'Modal',
  props: {
    title: null
  },
  emits: ['completed'],
  setup(__props: any, { emit }) {

const props = __props as {
    title: string
  }

  

  
  
  const name = ref('');
   onMounted(() => {
    const input = document.getElementById('selectNameInput');
    if (input) {
      input.focus();
    }
  })

  function completed() {
    emit('completed', name.value);
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createElementVNode("label", _hoisted_3, _toDisplayString(__props.title), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "selectNameInput",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
          class: "input",
          maxlength: "20",
          onKeypress: _withKeys(completed, ["enter"])
        }, null, 40, _hoisted_5), [
          [_vModelText, name.value]
        ]),
        _createElementVNode("button", {
          class: "enter-button",
          type: "submit",
          onClick: completed,
          "aria-label": "Use name"
        }, _hoisted_7)
      ])
    ])
  ]))
}
}

})